export let model = {};
model.page = {
    pageNumber: '18',
    title: 'Debriefing',
    subTitle: 'Real-time point-of-care debriefing by team members after a critical event AFTER the patient has been stabilized and transferred or patient care activities have ceased'
};

model.stepSets = [
    [
        {
            id: '100',
            main: 'Lay the ground rules <span class="plain-text">(see What we BELIEVE box)</span>',
        },
        {
            id: '101',
            main: 'Check-in',
            subContent: {
                contentType: 'action-list',
                items: [
                    '<em>"How is everyone doing?"</em>',
                    'Assess if team members feel able to continue providing care',
                ]
            },
        },
        {
            id: '102',
            main: 'Assess for immediate safety concerns to address',
            subContent: {
                contentType: 'action-list',
                items: [
                    '<b>Malfunctioning equipment or drugs</b> to sequester?',
                    'Any remaining <b>patient care needs</b> to address',
                    'Scheduling/staffing/resource <b>adjustments</b> for following cases?',
                ]
            },
        },
        {
            id: '103',
            main: 'Provide space for team reactions',
            subContent: {
                contentType: 'action-list',
                items: [
                    'Briefly summarize the case',
                    'Listen to team member emotional reactions',
                ]
            },
        },
        {
            id: '104',
            main: 'Reflect on the care delivered',
            subContent: {
                contentType: 'action-list',
                items: [
                    {
                        text: '<em>"What went well?"</em>',
                    },
                    {
                        text: '<em>"What could have gone better?"</em>',
                        subList: [
                            '<em>"What should we do differently in the future?"</em>',
                        ]
                    },
                    {
                        text: '<em>"Any lessons learned that we should share more broadly?"</em>',
                    }
                ]
            },
        },
        {
            id: '105',
            main: 'Remind team of resources available <span class="plain-text"> - see “Local RESOURCES”</span>',
            subContent: {
                contentType: 'action-list',
                items: [
                    'Emphasize <b>peer support programs</b> and <b>employee assistance programs</b>',
                ]
            },
        },
        {
            id: '106',
            main: 'Consider any needed follow up',
            subContent: {
                contentType: 'action-list',
                items: [
                    'Team member mental health needs',
                    'Safety or quality improvement reporting needs',
                    'OR operational needs'
                ]
            },
        }
    ]
];

model.references = {
    'what-we-believe' : {
        id: 'what-we-believe',
        header: 'What we <b>BELIEVE</b>',
        layout: 'vertical-sections',
        sections: [
            {
                contentType: 'text',
                contentItems: [
                  'We believe that everyone involved in this event is capable well trained and committed to delivering the best possible care',
                  'Our goal is to support one another and improve the care we give, not to assign blame'
                ],
            },
        ]
    },

    'elements-of-debriefing' : {
        id: 'elements-of-debriefing',
        header: 'Elements of Debriefing: <b>"WATER"</b>',
        layout: 'vertical-sections',
        sections: [
            {
                contentType: 'text',
                contentItems: [
                  '<img src="../../build/images/debriefing-water.png" alt="Water Droplet" style="height: 100%; position: absolute; top: 0; right: 0; object-fit: contain; border-bottom-right-radius: 2px;"/>',
                  '<b>W</b>elfare check (Step 2)',
                  '<b>A</b>cute Corrections (Step 3)',
                  '<b>T</b>eam Reactions and Reflections (Step 4)',
                  '<b>E</b>ducation (Step 5)',
                  '<b>R</b>esource Awareness (Steps 6 & 7)',
                ],
            },
        ]
    },

    'local-resources': {
        id: 'local-resources',
        header: 'Local <b>RESOURCES</b>',
        layout: 'vertical-sections',
        sections: [
            {
                contentType: 'local-resources',
                info: 'Please edit instructions for use to be specific to your institution’s device(s).',
                editable: true,
                contentItems: [{
                        main: 'Patient Safety Concerns:',
                        editable: true,
                        deletable: true,
                        info: 'Please edit instructions for use to be specific to your institution’s device(s).',
                        subContents: [
                            { subItem: 'Administrator On-Call', editable: true, deletable: true },
                            { subItem: 'Quality and Safety Leadership', editable: true, deletable: true },
                        ]
                    },
                    {
                        main: 'Operating Room Operations:',
                        editable: true,
                        deletable: true,
                        info: 'Please edit instructions for use to be specific to your institution’s device(s).',
                        subContents: [
                            { subItem: 'Administrator On-Call', editable: true, deletable: true },
                            { subItem: 'Charge Nurse', editable: true, deletable: true },
                            { subItem: 'Anesthesiologist in Charge', editable: true, deletable: true },
                            { subItem: 'Division Chief', editable: true, deletable: true },
                        ]
                    },
                    {
                        main: 'Emotional Support:',
                        editable: true,
                        deletable: true,
                        info: 'Please edit instructions for use to be specific to your institution’s device(s).',
                        subContents: [
                            { subItem: 'Peer Support Program Leader', editable: true, deletable: true },
                            { subItem: 'Employee Assistance Program', editable: true, deletable: true },
                            { subItem: 'Trained Debriefing Facilitator', editable: true, deletable: true },
                        ]
                    },
                    {
                        main: 'Legal Concerns:',
                        editable: true,
                        deletable: true,
                        info: 'Please edit instructions for use to be specific to your institution’s device(s).',
                        subContents: [
                            { subItem: 'Risk Management', editable: true, deletable: true },
                            { subItem: 'Hospital Legal Team', editable: true, deletable: true },
                        ]
                    }
                ],
            },
        ]
    },
};